import React from 'react';
import { Box, useTheme } from '@mui/material';
import { UIContext } from '../../../../context/UIContext';

interface TableWrapperProps {
  children: React.ReactNode;
}

const TableWrapper = ({ children }: TableWrapperProps) => {
  const { isMobile, colorMode } = React.useContext(UIContext);
  const theme = useTheme();

  if (isMobile) {
    return (
      <Box
        sx={{
          borderTop: `1px solid ${
            colorMode === 'light' ? theme.palette.grey['12p'] : theme.palette.grey['23p']
          }`,
          borderRadius: 0,
        }}
      >
        <Box
          sx={{
            height: 'auto',
            minHeight: 'auto',
            overflow: 'auto',
            '& .MuiDataGrid-root': {
              overflow: 'visible',
            },
            '& .MuiDataGrid-virtualScroller': {
              overflow: 'auto !important',
            },
          }}
        >
          {children}
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        maxHeight: 'calc(100vh - 394px)',
        minHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Box>
  );
};

export default TableWrapper;
